export const baseUrl = process.env.REACT_APP_BASE_URL || "https://whitelabel.admin.theassetmanager.co.uk/api/v1";
